import { Component, OnInit } from '@angular/core';
import { BrowserDynamicTestingModule } from '@angular/platform-browser-dynamic/testing';

@Component({
  selector: 'app-composicao',
  templateUrl: './composicao.component.html',
  styleUrls: ['./composicao.component.css']
})
export class ComposicaoComponent implements OnInit {

  // op1: boolean = false;
  // op2: boolean = false;

  constructor() {

  }

  ngOnInit() {
    window.onload = function () {
      document.getElementById("bt1").click();
    }
  }
  
  Mudarestado(el) {
    var display = document.getElementById(el).style.display;

    if (display == "none") {
      document.getElementById(el).style.display = 'block';
    }
    else
      document.getElementById(el).style.display = 'none';
  }

  op1() {
    var mnatos = document.getElementById("mnatos");
    var btnatos = document.getElementById('btnatos');
    var mdes = document.getElementById("mdes");
    var mnatos = document.getElementById("mnatos");
    var btdes = document.getElementById("btdes");

    if (mnatos.style.display == 'none') {
        mnatos.style.display = 'block';
        mdes.style.display = 'none';
        btnatos.style.borderLeft = '4px solid #00afec';
        btnatos.classList.add('bold');
        btdes.style.borderLeft = 'none';
        btdes.classList.remove('bold');
    } else {
        mnatos.style.display = 'none';
        btnatos.style.borderLeft = 'none';
        btnatos.classList.remove('bold');
        btdes.style.borderLeft = 'none';
        btdes.classList.remove('bold');
    }
  }

  op2() {
    var btdes = document.getElementById("btdes");
    var btnatos = document.getElementById('btnatos');
    var mdes = document.getElementById("mdes");
    var mnatos = document.getElementById("mnatos");

    if (mdes.style.display == 'none') {
      mdes.style.display = 'block';
      mnatos.style.display = 'none';
      btdes.style.borderLeft = '4px solid #00afec';
      btdes.classList.add('bold');
      btnatos.style.borderLeft = 'none';
      btnatos.classList.remove('bold');
    } else {
      mdes.style.display = 'none';
      btdes.style.borderLeft = 'none';
      btdes.classList.remove('bold');
      btnatos.style.borderLeft = 'none';
      btnatos.classList.remove('bold');
    }
  }


Mudaricone(l, icone) {
    var display = document.getElementById(l).style.display;
    if (display == "block") {
      document.getElementById(icone).style.transform = "rotate(90deg)";
    }
    else
      document.getElementById(icone).style.transform = "rotate(360deg)";
  }
}


// WEBPACK FOOTER //
// ./src/app/portal-cmcti/composicao/composicao.component.ts